import * as React from "react";
import type { SVGProps } from "react";
const SvgParkingSign = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 7c0-.55.45-1 1-1h4c1.65 0 3 1.35 3 3v1c0 1.65-1.35 3-3 3h-3v4c0 .55-.45 1-1 1s-1-.45-1-1zm2 1h3c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-3z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 22h12c2.21 0 4-1.79 4-4V6c0-2.21-1.79-4-4-4H6C3.79 2 2 3.79 2 6v12c0 2.21 1.79 4 4 4M4 6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgParkingSign;
